import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const LANGUAGES = {
  de: { code: "de", name: "Deutsch", flag: "🇩🇪" },
  en: { code: "en", name: "English", flag: "🇬🇧" }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem("monaco_language");
    return saved || "de"; // Default to German
  });

  useEffect(() => {
    localStorage.setItem("monaco_language", language);
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === "de" ? "en" : "de");
  };

  const switchLanguage = (lang) => {
    if (LANGUAGES[lang]) {
      setLanguage(lang);
    }
  };

  // Helper to get localized text from settings
  // settings can have: field_de, field_en or just field (fallback)
  const t = (settings, field, fallback = "") => {
    if (!settings) return fallback;
    
    // Try language-specific field first
    const langField = `${field}_${language}`;
    if (settings[langField] !== undefined && settings[langField] !== "") {
      return settings[langField];
    }
    
    // Fallback to non-localized field
    if (settings[field] !== undefined && settings[field] !== "") {
      return settings[field];
    }
    
    return fallback;
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage: switchLanguage, 
      toggleLanguage,
      t,
      isGerman: language === "de",
      isEnglish: language === "en"
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export default LanguageContext;
